function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import colors from "styles/colors";
import { BACKGROUND_GRAY_COLOR_NAME } from "styles/color-consts";
// docs: https://react-select.com/styles#the-styles-prop
export default function getReactSelectStyles(invalid) {
    const selectStyles = {
        control: (styles)=>_object_spread_props(_object_spread({}, styles), {
                minHeight: "40px",
                borderColor: `${invalid ? colors.red : colors.wolf}`
            }),
        menu: (styles)=>_object_spread_props(_object_spread({}, styles), {
                padding: "8px",
                zIndex: 20
            }),
        option: (styles, state)=>_object_spread_props(_object_spread({}, styles), {
                textAlign: "left",
                padding: "10px 8px 10px 8px",
                color: "black",
                backgroundColor: state.isFocused ? colors[BACKGROUND_GRAY_COLOR_NAME] : "transparent"
            }),
        multiValue: (styles)=>_object_spread_props(_object_spread({}, styles), {
                backgroundColor: "#DED4FC",
                height: "30px",
                borderRadius: "20px",
                padding: "4px 10px 4px 10px"
            }),
        multiValueLabel: (styles)=>_object_spread_props(_object_spread({}, styles), {
                fontSize: "12px",
                display: "flex",
                alignItems: "center"
            }),
        multiValueRemove: (styles)=>_object_spread_props(_object_spread({}, styles), {
                height: "100%",
                borderRadius: "20px",
                stroke: "rgba(0, 0, 0, 0.7)",
                "&:hover": {
                    stroke: "rgba(0, 0, 0, 1)",
                    backgroundColor: "transparent"
                }
            }),
        indicatorsContainer: (styles)=>_object_spread_props(_object_spread({}, styles), {
                paddingLeft: "0px"
            }),
        indicatorSeparator: (styles)=>_object_spread_props(_object_spread({}, styles), {
                visibility: "hidden",
                width: "0px"
            })
    };
    return selectStyles;
}
